import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ComponentWrapper = styled(Wrapper)`
  margin: 48px 0;
`;

export const HeadWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 12px 0;
  `}
`;

export const WhereFromLabel = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const WizardContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    margin-bottom: 24px;
    padding: 24px;
  `};
`;

export const DnsContentWrapper = styled.div`
  ${({ $expanded }) => css`
    max-height: ${$expanded ? '1000px' : '0px'};
    transition: .2s ease-in;
    overflow: hidden;
  `}
`;

export const DnsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 40px;
    margin: 16px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 20px;
      max-width: 316px;
      width: -webkit-fill-available;
    }
  `}
`;

export const DnsContentDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;

    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const DnsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ArrowBox = styled.div`
  ${({ theme }) => css`
    align-self: center;
    height: fit-content;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  `};
`;

export const DnsCardTitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const DnsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

export const ServerValue = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
  `}
`;

export const ServerLabel = styled(ServerValue)`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-weight: ${theme.v2.font.weights.medium};
  `};
`;

export const ChipsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 8px 0 24px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  position: relative;
  margin-bottom: 24px;
`;

export const StepDnsRow = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 16px;
    width: auto;
  `}
`;

export const StepLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    white-space: nowrap;
  `}
`;

export const StepValue = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.list};
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const IconButtonWrapper = styled.div`
  align-self: end;
`;

export const OriginalDnsContainer = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 100%;
    justify-content: center;
    min-width: 280px;
    padding: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 8px;
      height: auto;
      min-width: auto;
      width: auto;
    }
  `}
`;

export const OriginalDnsLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    display: ruby;
    font-weight: ${theme.v2.font.weights.regular};
  `};
`;

export const OriginalDnsText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;
